import { AfterContentInit, ChangeDetectorRef, Component, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngxs/store';
import { PuzzleFrameworkService } from 'projects/tools/src/lib/puzzle-framework-module/puzzle-framework.service';
import { LeaderboardService } from 'projects/tools/src/lib/shared-module/leaderboard/leaderboard.service';
import { Button } from 'projects/tools/src/lib/shared-module/buttons/button.def';
import { PUZZLE_WIN_DIALOG_BUTTONS, PuzzleWinDialogService } from './puzzle-win-dialog.service';
import { Subscription } from 'rxjs';
import {
  ModalController,
  IonButton,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonRow,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { backspaceSharp, refreshSharp, printSharp, sendSharp } from 'ionicons/icons';
import { LeaderboardWinDialogComponent } from 'projects/tools/src/lib/shared-module/leaderboard-win-dialog/leaderboard-win-dialog.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { TranslateModule } from '@ngx-translate/core';
import { PuzzleChangerFormComponent } from 'projects/tools/src/lib/shared-module/puzzle-changer-form/puzzle-changer-form.component';

@Component({
  selector: 'lib-app-puzzle-win-dialog',
  templateUrl: './puzzle-win-dialog.component.html',
  styleUrls: ['./puzzle-win-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    IonButton,
    IonCol,
    IonContent,
    IonFooter,
    IonGrid,
    IonHeader,
    IonIcon,
    IonItem,
    IonRow,
    IonTitle,
    IonToolbar,
    LeaderboardWinDialogComponent,
    PuzzleChangerFormComponent,
  ],
})
export class PuzzleWinDialogComponent implements AfterContentInit, OnDestroy {
  @ViewChild('inject', { static: true, read: ViewContainerRef }) injectViewContainerRef: ViewContainerRef;

  solutionWord: string;
  solutionUrl: string;

  public dialogTitle: string;
  private solutionWordSubscription: Subscription;
  private winDialogButtonSubscription: Subscription;
  private leaderboardVisibleSubscription: Subscription;

  showBackButton: boolean;
  showRestartButton: boolean;
  showLeaderboard = true;

  public sweepstakeEnabled = false;
  public showScreenshotButton = false;
  public screenshotPending = false;

  constructor(
    // public dialogRef: MatDialogRef<PuzzleWinDialogComponent>,
    private puzzleEvents: PuzzleFrameworkService,
    private store: Store,
    private framework: PuzzleFrameworkService,
    private winDialogService: PuzzleWinDialogService,
    // @Inject(MAT_DIALOG_DATA) public data: any,
    private viewContainerRef: ViewContainerRef,
    private ionicModal: ModalController,
    public device: DeviceDetectorService,
    private cd: ChangeDetectorRef,
    public leaderboard: LeaderboardService
  ) {
    addIcons({
      backspaceSharp,
      refreshSharp,
      printSharp,
      sendSharp,
    });
    // this.dialogRef.disableClose = true;
    if (this.framework.puzzleFrameworkConfig.solutionUrl) {
      this.solutionUrl = this.framework.puzzleFrameworkConfig.solutionUrl;
    }
    this.solutionWordSubscription = this.winDialogService.solutionWord$.subscribe((solutionWord) => {
      this.solutionWord = solutionWord;
    });

    this.winDialogButtonSubscription = this.winDialogService.buttons$.subscribe((buttons) => {
      this.showBackButton = buttons.indexOf(PUZZLE_WIN_DIALOG_BUTTONS.BACK_TO_GAME) !== -1;
      this.showRestartButton = buttons.indexOf(PUZZLE_WIN_DIALOG_BUTTONS.RESTART_GAME) !== -1;
    });

    this.leaderboardVisibleSubscription = this.winDialogService.leaderboardVisible$.subscribe((visible) => {
      this.showLeaderboard = visible;
    });

    this.sweepstakeEnabled = this.framework.puzzleFrameworkConfig.solutionWordConfig.sweepstake.enabled;

    this.winDialogService.winDialogTitle$.subscribe((title) => {
      this.dialogTitle = title;
    });

    // Send an event to the parent window to notify that the puzzle has been solved
    window.parent.postMessage('puzzleSolved', '*');
  }

  ngAfterContentInit(): void {
    this.winDialogService.registerViewContainer(this.viewContainerRef, this.injectViewContainerRef);

    if (this.framework.puzzleFrameworkConfig.winScreenPrintButton && document.getElementById('puzzle-screenshot')) {
      this.showScreenshotButton = true;
    }
  }

  ngOnDestroy(): void {
    this.solutionWordSubscription.unsubscribe();
    this.winDialogButtonSubscription.unsubscribe();
    this.leaderboardVisibleSubscription.unsubscribe();
  }

  sendSolutionWord() {
    this.framework.sendSolutionWordData(this.solutionWord);
  }

  async closeDialog(reset: boolean) {
    // await this.dialogRef.close(reset);
    await this.ionicModal.dismiss();
    if (reset) {
      this.puzzleEvents.buttonBarEmitButton(Button.Reset);
    }
  }

  async makeScreenshot() {
    window.print();
    // this.screenshotPending = true;
    // const dataUrl = await  domtoimage.toJpeg(document.getElementById('puzzle-screenshot'), {
    //   quality: 0.95,
    //   bgcolor: '#ffffff'
    // });
    // const link = document.createElement('a');
    // link.download = 'screenshot.jpeg';
    // link.href = dataUrl;
    // link.click();
    // this.screenshotPending = false;
  }
}
